/** The builder's checks: what to fix before Create, then what's worth a look. A check about a field takes you to it. */

import React from 'react';
import type { PlanCheck } from '../planChecks';

interface Props {
  checks: PlanCheck[];
  onGoTo: (field: string) => void;
}

const ChecksList: React.FC<Props> = ({ checks, onGoTo }) => {
  const fix = checks.filter((c) => c.tone === 'fix');
  const review = checks.filter((c) => c.tone === 'review');
  const group = (title: string, items: PlanCheck[], color: string) =>
    items.length > 0 && (
      <div>
        <div style={{ ...styles.groupTitle, color }}>{title}</div>
        <ul style={styles.list}>
          {items.map((c) => (
            <li key={c.id} style={styles.item}>
              <span aria-hidden="true" style={{ ...styles.dot, background: color }} />
              {c.field ? (
                <button type="button" style={styles.link} onClick={() => onGoTo(c.field!)}>
                  {c.message}
                </button>
              ) : (
                <span>{c.message}</span>
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      {group('To fix', fix, 'var(--danger)')}
      {group('To review', review, 'var(--warning)')}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  groupTitle: { fontSize: 11, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: 6 },
  list: { margin: 0, padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 6 },
  item: { display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 12.5, color: 'var(--fg-2)', lineHeight: 1.45 },
  dot: { flexShrink: 0, width: 6, height: 6, borderRadius: '50%', marginTop: 6 },
  link: { padding: 0, border: 'none', background: 'transparent', textAlign: 'left', cursor: 'pointer', fontFamily: 'var(--font-sans)', fontSize: 12.5, lineHeight: 1.45, color: 'var(--fg-link)', textDecoration: 'underline', textUnderlineOffset: 2 },
};

export default ChecksList;
